/**
 * Created by Alex Xia on 11/20/2020.
 * Description:
 * ------ maintenance history ------
 * 03/29/2021   Alex Xia create DashboardMapAutocompleteBaseComponent to share some methods to map-autocomplete and map-trip-autocomplete
 */
import { Component, OnInit, Output, EventEmitter, ElementRef, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { ContactService } from '@tamalelibs/services/contact.service';
import { AutocompleteActionType, MapContactModel } from './tam-dashboard-map-autocomplete.model';
import { DashboardTileService } from '../../dashboard-tile.service';
import { MapConfig } from '../tam-dashboard-map/tam-dashboard-map.model';
import { DashboardMapAutocompleteBaseComponent } from './dashboard-map-autocomplete.base';
import { TamDashboardEvents } from '../../tam-dashboard.model';
import { StoreQuerierService } from '../../../../services/store-querier.service';

@Component({
    selector: 'tam-dashboard-map-autocomplete',
    templateUrl: './tam-dashboard-map-autocomplete.html',
    styleUrls: ['./tam-dashboard-map-autocomplete.scss'],
    standalone: false
})
export class TamDashboardMapAutocompleteComponent extends DashboardMapAutocompleteBaseComponent implements OnInit, OnDestroy {
    @Input() config: MapConfig;
    @Output() eventSubject$ = new EventEmitter<any>();

    anchor: ElementRef;
    canShowDetail = true;
    hiddenTimeout: any;
    isBoxHoverOn = false;
    isBoxShow = true;
    isIconShow = true;
    isOuterBoxShow = true;
    isPopUpShow = false;
    selectedMapContact: MapContactModel;

    constructor(
        protected _contactService: ContactService,
        protected _dashboardTileService?: DashboardTileService,
        protected _changeDetectorRef?: ChangeDetectorRef,
        protected _storeQuerier?: StoreQuerierService
    ) {
        super(_contactService, _dashboardTileService, _changeDetectorRef, _storeQuerier);
    }

    ngOnInit() {
        if (this.config) {
            this.userInput = this.config.inputValue;
            this._initSubscriptions();
            this.destroySubscriptions.push(
                this.config.actionSubject$.subscribe(action => this._onSubscribeActions(action)));
            if (this.userInput) {
                this._getAllPredicitons();
            }
        }
    }

    ngOnDestroy() {
        this.destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this.subscribed = false;
    }

    directToMapTrip(directToMapTrip) {
        if (!directToMapTrip) {
            directToMapTrip = this.selectedMapContact;
        }
        // fix TAM-34501 ,becuase if no map init ,the trip can't be load .So get address lat lng and show on map.
        this.eventSubject$.emit({ type: AutocompleteActionType.predictionSelected, payload: { mapContactModel: directToMapTrip } });
        this.eventSubject$.emit({ type: AutocompleteActionType.directToMapTrip, payload: directToMapTrip, isFromDirectionInput: true });
    }

    /*
     * trigger when user input value
     * need to include contacts in tamale and google predictions.
    */
    keyUpHandler() {
        this.isPopUpShow = false;
        this._getAllPredicitons();
    }

    /**
     * emit the prediciton selected to map tile
     */
    predictionSelected(suggestion: any) {
        // clear variables
        this.selectedMapContact = suggestion;
        this.userInput = suggestion.contact ? suggestion.contact.name : suggestion.selectedAddress;
        this.predictionArray = [];
        this.isItemDetailShow = true;

        this.eventSubject$.emit({ type: AutocompleteActionType.predictionSelected, payload: { mapContactModel: suggestion } });
    }

    searchDirectly() {
        if (this.userInput && this.userInput.length > 0) {
            const mapContactModel = new MapContactModel();
            mapContactModel.selectedAddress = this.userInput;
            this.eventSubject$.emit({ type: AutocompleteActionType.predictionSelected, payload: { mapContactModel: mapContactModel } });
        }
    }

    clickSearchNearby() {
        const mapContactModel = new MapContactModel();
        mapContactModel.selectedAddress = this.userInput;
        this.eventSubject$.emit({ type: AutocompleteActionType.searchNearby, payload: mapContactModel, isTrip: false, isSelect: true });
    }

    showPopup(event: any) {
        this.anchor = event.target || event;
        this.isItemDetailShow = false;
        if (!this.userInput) {
            this.isPopUpShow = false;
        }
        this.isFocus = false;
    }

    changeBoxStatus() {
        this.isBoxShow = !this.isBoxShow;
        this.isBoxHoverOn = false;
        if (this.isBoxShow) {
            clearTimeout(this.hiddenTimeout);
            this.isOuterBoxShow = true;

            /**
             * icons, dropdown and detail box should appear after the box fully expands
             */
            setTimeout(() => {
                this.isIconShow = true;
                this.isPopUpShow = this.userInput ? true : this.isPopUpShow;
                this.canShowDetail = true;
            }, 300);
        } else {
            /**
             * outer-box should fully disappear after its width becomes 0px
             */
            this.hiddenTimeout = setTimeout(() => {
                this.isOuterBoxShow = false;
            }, 300);
            this.isIconShow = false;
            this.canShowDetail = false;
        }
    }

    boxHoverOn() {
        this.isBoxHoverOn = true;
    }

    boxMouseOut() {
        this.isBoxHoverOn = false;
    }

    /**
     * process action for config subscribe
     *
     * @private
     * @param {*} action
     * @memberof TamDashboardMapAutocompleteComponent
     */
    private _onSubscribeActions(action) {
        if (action.type === TamDashboardEvents.REFRESH_MAP_TILE) {
            if (action.isRefresh) {
                this.canShowDetail = false;
                this.userInput = null;
                this.isPopUpShow = false;
            } else {
                this.canShowDetail = true;
                this.isPopUpShow = true;
            }
        }
    }
}
